module.exports = __webpack_public_path__ + "canada.4d2c0a19.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/countries/canada.png
// module id = 121
// module chunks = 0